<template>
  <v-card>
    <v-card-title>Rekapan Jurnal Harian</v-card-title>
    <v-card-text>
      <form
        @submit.prevent="
          () => {
            options.page = filter.page = 1;
            get();
          }
        "
      >
        <v-row>
          <v-col cols="12" lg="4">
            <v-btn
              role="a"
              target="_blank"
              :href="pdf_url"
              text
              color="red"
              dark
            >
              Export PDF
            </v-btn>
          </v-col>
          <v-col cols="6" lg="4">
            <v-autocomplete
              :items="data.guru"
              v-model="filter.guru_id"
              @change="
                options.page = filter.page = 1;
                get();
              "
              clearable
              label="Pilih Guru"
              :disabled="$root.app.xlevel == 'user' ? true : false"
            ></v-autocomplete>
          </v-col>
          <v-col cols="6" lg="4">
            <v-dialog v-model="modal.date" max-width="290px" min-width="auto">
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="tampil.tanggal"
                  label="Tanggal"
                  prepend-icon="mdi-calendar"
                  v-bind="attrs"
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker
                :value.sync="filter.tanggal"
                @input="setTanggal"
              ></v-date-picker>
            </v-dialog>
          </v-col>
        </v-row>
      </form>
      <v-data-table
        :footer-props="{
          'items-per-page-options': [5, 10, 20, 50, 100],
        }"
        disable-sort
        :headers="[
          {
            text: 'Hari, Tanggal',
            value: 'tanggal',
          },
          {
            text: 'Guru',
            value: 'guru.nama',
          },
          {
            text: 'Mata Pelajaran',
            value: 'mata_pelajaran.nama',
          },
          {
            text: 'Pokok Bahasan',
            value: 'pokok_bahasan',
          },
          {
            text: 'Rombel / Ruang / Jam Ke',
            value: 'jadwal',
          },
          {
            text: 'Jml Siswa Hadir',
            value: 'siswa_hadir',
          },
        ]"
        :items="datas"
        :loading="is.loading"
        loading-text="Loading... Please wait"
        :server-items-length="recordsTotal"
        :options.sync="options"
      >
        <template slot="item.jadwal" slot-scope="{ item }">
          <span>
            {{ item.rombel ? item.rombel.rombel : "-" }}
            /
            {{ item.ruang || "-" }}
            /
            {{ item.jam_kbm_full }}
          </span>
        </template>

        <template slot="item.tanggal" slot-scope="{ item }">
          {{ item.hari.toUpperCase() }},
          {{ item.tanggal }}
        </template>
      </v-data-table>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  data() {
    return {
      datas: [],
      data: {
        guru: [],
      },
      modal: {
        date: false,
        anulir: false,
      },
      req: {},
      is: {
        loading: true,
      },
      filter: {
        limit: 10,
        search: "",
        page: 1,
      },
      options: {},
      recordsTotal: 0,
      pdf_url: "",
      tampil: {
        tanggal: "",
      },
    };
  },
  watch: {
    options(val) {
      this.filter.limit = val.itemsPerPage;
      this.filter.page = val.page;
      this.get();
    },
  },
  created() {
    this.filter.guru_id = parseInt(this.$root.app.xid);

    this.getHariIni();
    this.get();
    this.getData();
  },
  methods: {
    setTanggal(val) {
      this.modal.date = false;
      this.filter.tanggal = val;

      const date = new Date(val);
      var tanggal =
        (date.getDate() > 9 ? date.getDate() : "0" + date.getDate()) + "/";
      tanggal +=
        (date.getMonth() + 1 > 9
          ? date.getMonth() + 1
          : "0" + (date.getMonth() + 1)) + "/";
      tanggal += date.getFullYear();
      this.tampil.tanggal = tanggal;

      this.filter.page = 1;
      this.get();
    },
    getHariIni() {
      const date = new Date();
      var tanggal = date.getFullYear() + "-";
      tanggal +=
        (date.getMonth() + 1 > 9
          ? date.getMonth() + 1
          : "0" + (date.getMonth() + 1)) + "-";
      tanggal += date.getDate() > 9 ? date.getDate() : "0" + date.getDate();

      this.setTanggal(tanggal);
    },
    get() {
      this.req = {};
      this.is.loading = true;
      this.filter.status = "1";

      if (this.filter.guru_id == null) {
        this.filter.guru_id = "";
      }

      this.$root.app.http
        .get("/api/matapelajaran/jurnalmengajar", this.filter)
        .then((res) => {
          this.pdf_url = res.pdf_url;
          this.datas = res.data;
          this.recordsTotal = res.recordsTotal;
          this.is.loading = false;
        });
    },
    getData() {
      this.data.guru = [
        {
          value: "",
          text: "Semua Guru",
        },
      ];
      this.$root.app.http.get("/api/guru").then((res) => {
        res.data.forEach((item) => {
          this.data.guru.push({
            value: item.id,
            text: item.nama,
          });
        });
      });
    },
  },
};
</script>
